import { ReactNode } from 'react';
import { ModuleTabs } from './ModulePage';

export default function ModulePageWrapper({ children }: { children: ReactNode }) {
  return (
    <div>
      <ModuleTabs />
      {children}
    </div>
  );
}
